export const MENU_ROUTE_PERMISSIONS = {
  dashboard: ['dashboard.view'],
  'order-summary': ['orders.view'],
  'all-orders': ['orders.view'],
  'order-reports': ['order_reports.view'],
  'sales-reports': ['sales_reports.view'],
  'returns-reports': ['returns_reports.view'],
  'order-analysis': ['order_analysis.view'],
  'sku-perfomance': ['sku_performance.view'],
  'kpi-overview': ['kpi_overview.view'],
  'ads-performance': ['ads_performance.view', 'imported_data.view', 'dashboard.view'],
  products: ['products.view'],
  inventory: ['products.view'],
  categories: ['categories.view'],
  brands: ['brands.view'],
  catalogs: ['catalog.view'],
  'manual-upload': ['imported_data.view', 'uploads.view'],
  'bulk-enhance': ['imported_data.view', 'imported_data.import'],
  'imported-reports': [
    'imported_data.view',
    'imported_catalog.view',
    'imported_order_reports.view',
  ],
  exports: [
    'exports.view',
    'exports_order_reports.view',
    'exports_sales_reports.view',
    'exports_catalog.view',
  ],
  'callback-sp': ['credentials.view'],
  'callback-ads': ['credentials.view'],
  'callback-salla': ['credentials.view'],
  'callback-zid': ['credentials.view'],
  noon: ['credentials.view'],
  trendyol: ['credentials.view'],
  'app-management': ['credentials.view'],
  subscription: ['credentials.view'],
  account: ['account.view'],
  'applicatiion-logs/central-log': ['logs.view'],
  'applicatiion-logs/system-error-log': ['logs.view'],
  roles: ['roles.view'],
  'user-management': ['users.view'],
};

export const ROUTE_PERMISSIONS = {
  dashboard: ['dashboard.view'],
  'order-summary': ['orders.view'],
  'all-orders': ['orders.view'],
  shipping: ['orders.view'],
  delivered: ['orders.view'],
  'new-orders': ['orders.view'],
  'order-reports': ['order_reports.view'],
  'sales-reports': ['sales_reports.view'],
  'returns-reports': ['returns_reports.view'],
  'order-analysis': ['order_analysis.view'],
  'sku-perfomance': ['sku_performance.view'],
  'kpi-overview': ['kpi_overview.view'],
  'ads-performance': ['ads_performance.view', 'imported_data.view', 'dashboard.view'],
  products: ['products.view'],
  'products/add': ['products.create', 'products.update'],
  'products/publish': ['products.publish', 'products.update'],
  categories: ['categories.view', 'products.view'],
  brands: ['brands.view'],
  catalog: ['catalog.view'],
  catalogs: ['catalog.view'],
  'manual-upload': ['imported_data.view', 'uploads.view'],
  'bulk-enhance': ['imported_data.view', 'imported_data.import'],
  'bulk-enhance/jobs/:jobId': ['imported_data.view', 'imported_data.import'],
  'imported-reports': [
    'imported_data.view',
    'imported_catalog.view',
    'imported_order_reports.view',
  ],
  exports: [
    'exports.view',
    'exports_order_reports.view',
    'exports_sales_reports.view',
    'exports_catalog.view',
  ],
  settings: ['credentials.view'],
  'callback-sp': ['credentials.view'],
  'callback-ads': ['credentials.view'],
  'callback-salla': ['credentials.view'],
  'callback-zid': ['credentials.view'],
  noon: ['credentials.view'],
  trendyol: ['credentials.view'],
  'app-management': ['credentials.view'],
  subscription: ['credentials.view'],
  'subscription/pay': ['credentials.view'],
  account: ['account.view'],
  'applicatiion-logs/central-log': ['logs.view'],
  'applicatiion-logs/system-error-log': ['logs.view'],
  roles: ['roles.view'],
  'user-management': ['users.view'],
  'access-denied': [],
  'my-profile': [],
  orders: ['orders.view'],
  inventory: ['products.view'],
  reports: ['order_reports.view'],
  ranking: ['order_reports.view'],
  'sales-trend': ['sales_reports.view'],
  'top-10': ['order_reports.view'],
  'top-winners': ['order_reports.view'],
  'top-loosers': ['order_reports.view'],
  'redirect-zid': ['credentials.view'],
};

/** Routes that require every listed permission (in addition to ROUTE_PERMISSIONS any-of). */
export const ROUTE_PERMISSIONS_ALL = {
  'products/add': ['categories.view', 'brands.view', 'catalog.view'],
};
